const SIGN_UP_FROM_AMZ = 'sign_up_from_amz';

export const isSignUpFromAmazon = () => {
  const storedSignUpFromAmz = sessionStorage.getItem(SIGN_UP_FROM_AMZ);
  return storedSignUpFromAmz === 'true';
};

export const setSignUpFromAmazon = () => {
  sessionStorage.setItem(SIGN_UP_FROM_AMZ, 'true');
};
